import {setupButtonClick} from "../utils/ui";
import LocalStorage from "../utils/localStorage";
import config from "../config";
import DbClient from "../db/client";

const GOLD_COLOR = "#EAC520";
const SILVER_COLOR = "#808080";
const BRONCE_COLOR = "#bf8970";

export default class IngameHighscore {
    static preload(scene){
        scene.load.image('global', 'src/assets/img/global.png');
        scene.load.image('local', 'src/assets/img/local.png');
    }

    constructor({scene}) {
        this.scene = scene;

        this.localHighscore = LocalStorage.getHighscore() || [];
        DbClient
            .getHighscore()
            .then(globalHighscore => {
                this.globalHighscore = globalHighscore;
            })
            .catch(e => {
            })

        this.localRank = this.createRank("Local", this.scene.game.config.width - 10, 80);
        this.globalRank = this.createRank("Global", this.scene.game.config.width - 10, 30);
    }

    update(score){
        if(this.localHighscore.length > 0){
            const rankLocalElement = this.localHighscore.find(highscoreEntry => highscoreEntry.score < score);
            let rankLocal = this.localHighscore.indexOf(rankLocalElement);
            if(rankLocal === -1 && this.localHighscore.length < config.HIGHSCORE.ENTRIES){
                rankLocal = this.localHighscore.length + 1 + ".";
            } else if(rankLocal === -1) {
                rankLocal = "99. ";
            } else {
                rankLocal += 1;
                rankLocal += ". ";
            }
            this.localRank.rankText.setText(rankLocal);
            this.localRank.rankTextBehind.setText(rankLocal);
            this.localRank.rankSizer.layout();
            this.localRank.layout();
        } else {
            this.localRank.rankText.setText("1. ");
            this.localRank.rankTextBehind.setText("1. ");
            this.localRank.rankSizer.layout();
            this.localRank.layout();
        }
        if(this.globalHighscore){
            const rankGlobalElement = this.globalHighscore.find(highscoreEntry => highscoreEntry.score < score);
            let rankGlobal = this.globalHighscore.indexOf(rankGlobalElement);
            if(rankGlobal === -1 && this.globalHighscore.length < config.HIGHSCORE.ENTRIES) {
                rankGlobal = this.globalHighscore.length + 1 + ".";
            } else if(rankGlobal === -1) {
                rankGlobal = "99.";
            } else {
                rankGlobal += 1;
                rankGlobal += ".";
            }
            this.globalRank.rankText.setText(rankGlobal);
            this.globalRank.rankTextBehind.setText(rankGlobal);
            this.globalRank.rankSizer.layout();
            this.globalRank.layout();
        }
    }

    createRank(id, x,y){

        const container = this.scene.rexUI.add.sizer({
            orientation: "x",
            anchor: "left",
            x,
            y,
            space: { left: 0, right:0, top:0, bottom:0, },
            ltr: false
        });

        const rankSizer = this.scene.rexUI.add.overlapSizer({
            x: 0,
            y: 0,
            // anchor: undefined,
            // width: undefined,
            // height: undefined,
            // space: { left: 0, right:0, top:0, bottom:0 },

            // name: '',
            // draggable: false,
            // sizerEvents: false,
            // enableLayer: false,
        });

        const fill = id === "Global" ? GOLD_COLOR : SILVER_COLOR;

        const rankTextBehind = this.scene.add.text(0, 0, `-.`,
            {
                fill: "#000",
                fontSize: "45px",
                fontFamily: "Splurge"
            });
        const rankText = this.scene.add.text(0, 0, `-.`,
            {
                fill,
                fontSize: "40px",
                fontFamily: "Splurge"
            });

        rankSizer.add(rankTextBehind, {align: "center"});
        rankSizer.add(rankText, {align: "center"});

        rankSizer.layout();

        const nameText = id === "Global" ? this.scene.add.image(0, 0, "global") :
            this.scene.add.image(0, 0, "local");

        nameText.setScale(0.5);

        let padding = id === "Global" ? 30 : 50;

        container.add(rankSizer);
        container.add(nameText, {padding: {left: padding}});
        container.layout();
        container.setDepth(2);
        container.setOrigin(1, 0.5);
        container.rankText = rankText;
        container.rankTextBehind = rankTextBehind;
        container.rankSizer = rankSizer;
        return container;
    }
}